import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./Home.css";
import image1 from  "../images/image1.jpg";
import image2 from  "../images/image2.jpg";
import image3 from  "../images/image3.jpeg";
import image4 from  "../images/image4.jpeg";
import caMadhuri from "../images/madhuri_image.jpg";

const Home = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const features = [
    { icon: "bi bi-briefcase-fill", title: "Expert Tax Advisory", desc: "Strategic tax planning & advisory from an experienced CA." },
    { icon: "bi bi-people-fill", title: "50+ Happy Clients", desc: "Trusted by businesses & individuals for financial excellence." },
    { icon: "bi bi-shield-lock-fill", title: "Secure & Confidential", desc: "Ensuring 100% data confidentiality & professional trust." },
    { icon: "bi bi-lightbulb-fill", title: "Business Consultancy", desc: "Guidance for startups & established businesses growth." },
    { icon: "bi bi-cash-stack", title: "GST & Tax Filing", desc: "Simplified tax compliance for hassle-free returns." },
    { icon: "bi bi-graph-up-arrow", title: "Investment Advisory", desc: "Maximize your wealth with expert financial strategies." },
  ];

  const testimonials = [
    { name: "Amit Sharma", review: "CA Madhuri's tax planning saved me thousands! Highly professional.", image: `${image1}` },
    { name: "Pooja Verma", review: "Best decision to trust CA Madhuri with our company audit.", image: `${image3}` },
    { name: "Rajesh Gupta", review: "Financial advisory helped us plan investments perfectly!", image: `${image2}` },
    { name: "Meena Kapoor", review: "Most reliable CA for all our business financial needs.", image: `${image4}`},
  ];

  return (
    <div className="container-fluid p-0">
      {/* Hero Section */}
      <div className="hero-section text-center text-dark d-flex align-items-center justify-content-center position-relative">
        <div className="overlay"></div>
        <motion.div 
          className="position-relative hero-title"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="p-3 bg-dark bg-opacity-20 text-white rounded shadow-lg">
            Welcome to CA Madhuri
          </h1>
          <p className="text-white mt-3" style={{fontSize: "1.3rem", textShadow: "1px 1px 3px rgba(0,0,0,0.8)"}}>
            Your Trusted Financial Partner for Success
          </p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            <Link to="/contact" className="btn btn-lg btn-primary mt-4" style={{background: "#667eea", border: "none", padding: "12px 30px", fontSize: "1.1rem"}}>
              Get Expert Consultation
            </Link>
          </motion.div>
        </motion.div>
      </div>

      {/* Features Section */}
      <div className="container py-5">
        <motion.h2 
          className="text-center fw-bold text-dark display-5 text-uppercase mb-5"
          style={{color: "#667eea"}}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Our Key Services
        </motion.h2>
        <div className="row justify-content-center">
          {features.map((feature, index) => (
            <motion.div 
              key={index} 
              className="col-md-4 d-flex align-items-stretch mb-4" 
              data-aos="fade-up"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="feature-card p-4 shadow-lg rounded w-100 text-center">
                <motion.i 
                  className={`${feature.icon} fs-2 text-white`}
                  style={{background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", padding: "15px", borderRadius: "50%"}}
                  initial={{ rotate: -180, opacity: 0 }}
                  whileInView={{ rotate: 0, opacity: 1 }}
                  transition={{ duration: 0.8 }}
                ></motion.i>
                <h5 className="mt-3 text-dark fw-bold">{feature.title}</h5>
                <p className="text-dark">{feature.desc}</p>
                <Link to="/contact" className="btn btn-sm" style={{background: "#667eea", color: "white", marginTop: "auto"}}>
                  Learn More
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* About CA Madhuri Section */}
      <motion.div 
        className="container py-5 my-5"
        style={{backgroundColor: "#f5f7fa", borderRadius: "15px"}}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        data-aos="fade-up"
      >
        <div className="row align-items-center">
          <div className="col-md-6">
            <h2 className="fw-bold mb-4" style={{color: "#667eea", fontSize: "2.2rem"}}>
              Meet CA Madhuri
            </h2>
            <p style={{fontSize: "1.1rem", color: "#555", lineHeight: "1.8", marginBottom: "15px"}}>
              <strong>CA Madhuri Chaudhari</strong> is a highly experienced Chartered Accountant with 3+ years of expertise in taxation, financial planning, and business advisory.
            </p>
            <p style={{fontSize: "1.1rem", color: "#555", lineHeight: "1.8", marginBottom: "15px"}}>
              Dedicated to transforming financial challenges into growth opportunities, Madhuri has successfully guided 50+ clients through complex financial landscapes with transparency and excellence.
            </p>
            <ul style={{fontSize: "1rem", color: "#555"}}>
              <li>✓ Expert in GST, Income Tax & Corporate Compliance</li>
              <li>✓ Specialization in Startup & SME Advisory</li>
              <li>✓ Proven track record of financial excellence</li>
              <li>✓ Personalized solutions for every client</li>
            </ul>
            <Link to="/about" className="btn btn-lg mt-4" style={{background: "#667eea", color: "white"}}>
              Know More About Madhuri
            </Link>
          </div>
          <div className="col-md-6 text-center">
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <img src={caMadhuri} alt="CA Madhuri" style={{width: "100%", borderRadius: "15px", boxShadow: "0px 15px 35px rgba(0, 0, 0, 0.2)"}} />
            </motion.div>
          </div>
        </div>
      </motion.div>

      {/* Testimonials Section */}
      <div className="container my-5">
        <motion.h2 
          className="text-center fw-bold text-dark display-5 text-uppercase mb-5"
          style={{color: "#667eea"}}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          What Our Clients Say
        </motion.h2>

        <div className="row justify-content-center">
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={index} 
              className="col-md-3 d-flex align-items-stretch mb-4" 
              data-aos="zoom-in"
              whileHover={{ y: -10 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="testimonial-card p-4 shadow-lg rounded w-100 text-center" style={{background: "linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)"}}>
                <motion.img 
                  src={testimonial.image} 
                  alt={testimonial.name} 
                  className="testimonial-img rounded-circle mb-3" 
                  whileHover={{ scale: 1.15 }}
                  transition={{ type: "spring", stiffness: 400 }}
                />
                <p style={{fontStyle: "italic", color: "#555", lineHeight: "1.6"}}>"{testimonial.review}"</p>
                <h5 className="mt-3 text-dark fw-bold" style={{color: "#667eea"}}>- {testimonial.name}</h5>
                <div style={{color: "#ffc107", fontSize: "1.2rem"}}>★★★★★</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <motion.div 
        className="container-fluid py-5 text-center text-white"
        style={{background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"}}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="fw-bold mb-4" style={{fontSize: "2.5rem"}}>Ready to Transform Your Finances?</h2>
        <p style={{fontSize: "1.2rem", marginBottom: "30px"}}>Get expert financial guidance from CA Madhuri today</p>
        <Link to="/contact" className="btn btn-lg btn-light fw-bold" style={{padding: "12px 40px", fontSize: "1.1rem"}}>
          Schedule a Consultation
        </Link>
      </motion.div>
    </div>
  );
};

export default Home;
